import { Controller } from "@hotwired/stimulus";
import i18n from "../lib/i18n";
import TomSelect from "tom-select";
import { defaultConfigTags } from "../config/tom-select";
import API from "../lib/API";
import { uniqueId } from "lodash-es";

export default class extends Controller {
  static targets = ["controlInput", "dropdownParent", "resetTagsValue"];
  static values = { otherTags: String, otherTagsCount: Number };

  connect() {
    this.customDropdown = new TomSelect(
      this.element.querySelector("select"),
      this.config()
    );
  }

  alreadyInitialized() {
    return this.element.querySelector("select").tomselect !== undefined;
  }

  config() {
    return Object.assign({}, defaultConfigTags, {
      controlInput: this.controlInputTarget,
      dropdownParent: this.dropdownParentTarget,
      create: true,
      onInitialize: this.onInitialize,
      load: this.load,
    });
  }

  onInitialize = () => {
    // Add button for removing other tags if any
    if (this.hasOtherTagsCountValue && Boolean(this.otherTagsCountValue)) {
      const text =
        this.element.querySelector(".chip-container").children.length > 0
          ? ` + ${this.otherTagsCountValue} ${i18n.t("js.stimulus_controllers.tag_list.diverging")}`
          : `${this.otherTagsCountValue} ${i18n.t("js.stimulus_controllers.tag_list.diverging")}`;

      const resetChipId = uniqueId("reset-chip-");
      this.element.querySelector(".chip-container").insertAdjacentHTML(
        "beforeend",
        `<span data-html="true" class="chip item multiple" data-value data-ts-item data-toggle="tooltip" title="${this.otherTagsValue}">
          ${text}
          <a href="javascript:void(0)" class="remove" tabindex="-1" title="Ta bort" id="${resetChipId}">
            <i class="fa fa-close"></i>
          </a>
        </span>`
      );

      this.element
        .querySelector(`#${resetChipId}`)
        .addEventListener("click", this.resetTags.bind(this));
    }

    // Fix styling of remove_button plugin
    document.querySelectorAll(".plugin-remove_button").forEach((item) => {
      item.classList.remove("plugin-remove_button");
    });

    // Attach listener to maintenance plan selector
    const planSelect = document.querySelector(
      "#maintenance_plan_action_maintenance_plan_id"
    );
    if (planSelect) {
      planSelect.addEventListener("change", () => {
        this.customDropdown.clearOptions();
        this.customDropdown.load("");
      });
    }
  };

  load = async (query, callback) => {
    const planID = document.querySelector(
      "#maintenance_plan_action_maintenance_plan_id"
    )?.value;

    let url = "/maintenance_plan_action_tags";
    if (planID) {
      url += `?maintenance_plan=${planID}`;
    }

    const response = await API.get(url);
    const result = await response.json();

    callback(
      result.data.map((item) => ({
        value: item.attributes.name,
        text: item.attributes.name,
      }))
    );
  };

  disconnect() {
    this.customDropdown?.destroy();
  }

  resetTags(e) {
    e.stopPropagation();
    const hiddenField = this.resetTagsValueTarget;
    const chip = e.currentTarget.parentElement;

    hiddenField.value = true;
    $(chip).tooltip("destroy");
    chip.remove();
  }
}
